import { render, staticRenderFns } from "./RequestVamNew.vue?vue&type=template&id=2c7fa740&scoped=true&"
import script from "./RequestVamNew.vue?vue&type=script&lang=js&"
export * from "./RequestVamNew.vue?vue&type=script&lang=js&"
import style0 from "./RequestVamNew.vue?vue&type=style&index=0&id=2c7fa740&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7fa740",
  null
  
)

export default component.exports